import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteData,
  getData,
  getDataById,
  postData,
  postDataWithParams,
  updateData,
} from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime: 0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getDeliveryOrder = createAsyncThunk(
  "admin/delivery-order",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData(
        "/admin/delivery-order",
        data.token,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getDeliveryOrderById = createAsyncThunk(
  "admin/delivery-order/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById(
        "/admin/delivery-order/",
        data.token,
        data.id
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortDeliveryOrder = createAsyncThunk(
  "admin/delivery-order/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "admin/delivery-order/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postDeliveryOrder = createAsyncThunk(
  "admin/delivery-order/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData(
        "/admin/delivery-order",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteDeliveryOrder = createAsyncThunk(
  "admin/delivery-order/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData(
        "/admin/delivery-order/",
        data.token,
        data.data
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateDeliveryOrder = createAsyncThunk(
  "admin/delivery-order/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/admin/delivery-order",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const deliveryOrderSlice = createSlice({
  name: "Delivery Order Store",
  initialState: initialState,
  reducers: {
    addDeliveryOrder(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortDeliveryOrder(state, action) {
      state.data.docs = action.payload;
    },
    deleteDeliveryOrder(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editDeliveryOrder(state, action) {
      let x = state.data.docs.findIndex(
        (item) => item._id === action.payload._id
      );
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getDeliveryOrder.pending]: (state) => {
      state.isLoading = true;
    },
    [getDeliveryOrder.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getDeliveryOrder.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDeliveryOrderById.pending]: (state) => {
      state.isLoading = true;
    },
    [getDeliveryOrderById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getDeliveryOrderById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDeliveryOrder.pending]: (state) => {
      state.isLoading = true;
    },
    [sortDeliveryOrder.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortDeliveryOrder.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postDeliveryOrder.pending]: (state) => {
      state.isLoading = true;
    },
    [postDeliveryOrder.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postDeliveryOrder.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteDeliveryOrder.pending]: (state) => {
      state.isLoading = true;
    },
    [deleteDeliveryOrder.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteDeliveryOrder.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateDeliveryOrder.pending]: (state) => {
      state.isLoading = true;
    },
    [updateDeliveryOrder.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateDeliveryOrder.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const deliveryOrderActions = deliveryOrderSlice.actions;

export default deliveryOrderSlice.reducer;
